<template>
  <div class="ktxc_SINGLE_CHOICE">
    <p class="stem">
      {{ data.questionStem.content }}
    </p>
    <div
      :style="{ background: `url(${data.questionStem.imgList[0].url}) no-repeat center/contain ` }"
      v-if="data.questionStem.imgList.length"
      @click.stop="optionImgLargeChange(data.questionStem.imgList[0].url)"
      class="stem_img"
    ></div>
    <section
      class="options "
      :style="{ '--cursor': userInfo.type !== 'STUDENT' || data.analysisFlag ? 'default' : 'pointer' }"
    >
      <div
        ref="optionView"
        :style="{
          '--width': item.imgList.length ? '242px' : '550px',
        }"
        :class="answerViewFn(data, index)"
        v-for="(item, index) in data.options"
        :key="index"
        @click="optionChange(data, index)"
      >
        <div
          v-if="item.imgList.length"
          :style="{
            backgroundImage: `url(${item.imgList[0].url})`,
          }"
          @click.stop="optionImgLargeChange(item.imgList[0].url)"
          class="option_img"
        ></div>
        <p>{{ optionsArr[index] }}：{{ item.content }}</p>
        <section v-if="data.analysisFlag">
          <i v-if="answerIconFn(data, index, 'yes')" class="icon yes el-icon-success"></i>
          <i v-if="answerIconFn(data, index, 'no')" class="icon no el-icon-error"></i>
        </section>
        <section class="studentInfo" v-if="currentStudentInfoIndex === index">
          <div>
            <p>{{ studentSubmitAnswer[index + ""] || "暂无学生提交~" }}</p>
          </div>
        </section>
      </div>
    </section>
    <picEnlarge ref="picEnlargeView"></picEnlarge>
  </div>
</template>

<script>
import { mapState } from "vuex";
import picEnlarge from "@/components/cmp-pic-enlarge-mask.vue";

export default {
  components: {
    picEnlarge,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      studentSubmitAnswer: {},
      currentStudentInfoIndex: -1,
    };
  },
  watch: {
    data: {
      handler(n) {
        if (typeof n.options === "string") n.options = JSON.parse(n.options || "");
        if (typeof n.questionStem === "string") n.questionStem = JSON.parse(n.questionStem || "");
        this.studentSubmitAnswer = {};
        n.answer = Number(n.answer);
        if (!n.details.length) n.details = [{}];
        // 整合作答学生数据
        if (this.userInfo.type !== "STUDENT" && n.details.length) {
          n.details.forEach((v) => {
            this.studentSubmitAnswer[Number(v.studentAnswer)] = v.studentName;
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(["optionsArr", "userInfo"]),
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("click", this.onClickOutside);
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onClickOutside);
  },
  methods: {
    onClickOutside(event) {
      let _this = this;
      if (_this.$refs.optionView && !_this.$refs.optionView[this.currentStudentInfoIndex].contains(event.target)) {
        this.currentStudentInfoIndex = -1;
      }
    },
    answerIconFn(data, index, type) {
      if (this.userInfo.type === "TEACHER") {
        return type === "yes" ? (data.answer === index ? true : false) : data.answer === index ? false : true;
      } else if (this.userInfo.type === "STUDENT") {
        if (type === "yes") {
          return (
            (Number(data.details[0].studentAnswer) === index && data.details[0].correct === 1) || data.answer === index
          );
        } else {
          return Number(data.details[0].studentAnswer) === index && data.details[0].correct === 0;
        }
      }
    },
    answerViewFn(data, index) {
      let obj = {};
      if (this.userInfo.type === "TEACHER" && data.analysisFlag) {
        obj = {
          bg: data.userAnswer === index,
          yes_bg: data.answer === index,
          no_bg: data.answer !== index,
        };
      } else if (this.userInfo.type === "STUDENT") {
        // 如果是学生
        if (data.analysisFlag) {
          // 教师答案解析开关打开
          obj = {
            bg: data.userAnswer === index,
            yes_bg: data.answer === index,
            no_bg: Number(data.details[0].studentAnswer) === index && data.details[0].correct === 0,
          };
        } else {
          // 教师答案解析开关未打开
          // 说明用户继续选答案
          if (data.userAnswer > -1) {
            obj = {
              bg: data.userAnswer === index,
            };
          } else {
            obj = {
              no_bg: Number(data.details[0].studentAnswer) === index,
            };
          }
        }
      }

      return obj;
    },
    //放大图片
    optionImgLargeChange(url) {
      this.$refs.picEnlargeView.show(url);
    },
    // 学生选择答案 老师查看每个单独选项提交人数
    optionChange(data, index) {
      if (this.userInfo.type !== "STUDENT") {
        this.currentStudentInfoIndex = index;
        return false;
      }
      if (this.userInfo.type !== "STUDENT" || data.analysisFlag) return false;
      this.$set(data, "userAnswer", index);
    },
  },
};
</script>

<style lang="less" scoped>
.ktxc_SINGLE_CHOICE {
  .stem {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .stem_img {
    // width: 760px;
    height: 140px;
    border-radius: 6px;
    margin-top: 10px;
    cursor: pointer;
  }
  .options {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 15px;
    position: relative;
    .studentInfo {
      position: absolute;
      width: 496px;
      height: 102px;
      background: #ffffff;
      border: 1px solid #19a4ff;
      left: 0;
      top: -103px;
      > div {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        p {
          margin-right: 20px;
        }
        &::before {
          position: absolute;
          z-index: 2;
          width: 14px;
          height: 10px;
          content: "";
          bottom: -2px;
          left: 88px;
          background: #fff;
        }
        &::after {
          position: absolute;
          z-index: 1;
          width: 10px;
          height: 10px;
          display: inline-block;
          content: "";
          bottom: -7px;
          left: 90px;
          border: 1px solid #19a4ff;
          transform: rotate(45deg);
        }
      }
    }
    div {
      width: var(--width);
      border: 1px solid transparent;
      border-radius: 6px;
      padding: 10px 30px 10px 10px;
      margin-bottom: 10px;
      position: relative;
      cursor: var(--cursor);
      .option_img {
        margin: 0 auto;
        width: 140px;
        height: 100px;
        border-radius: 6px;
        background-repeat: no-repeat;
        background-size: cover;
      }
      .icon {
        font-size: 20px;
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
      }
      .yes {
        color: #4add42;
      }
      .no {
        color: #ff4d4d;
      }
    }
    .no_bg,
    .bg {
      background: #edf5fb;
      border: 1px solid #19a4ff;
    }
    .yes_bg {
      background: #bff0bc;
      border: 1px solid #4add42;
    }
  }
}
</style>
